import anime, {AnimeInstance} from 'animejs'
import {ConnectedComponent,sharedComponent} from 'lowkey-component'

import {TextAnimation} from '@components/helpers/TextAnimation'
import {MediaQuery} from '@services/MediaQuery'
import {WindowService} from '@services/WindowService'
import {appSelectors} from '@store/appSlice'

@sharedComponent
export class Nav extends ConnectedComponent {
  mq = MediaQuery.create()
  window = WindowService.create()
  items: HTMLDivElement[] = []
  links: HTMLAnchorElement[] = []
  backs: HTMLDivElement[] = []
  currentIndex = 0
  anime: Map<HTMLElement, AnimeInstance> = new Map()
  textAnimations: Map<HTMLElement, TextAnimation> = new Map()

  constructor(element: HTMLDivElement) {
    super(element)
    this.resize = this.resize.bind(this)
    this.onPressLink = this.onPressLink.bind(this)
    this.onPressGoBack = this.onPressGoBack.bind(this)
  }

  didMount() {
    this.backs = [...this.element.querySelectorAll('.m-nav-item_back')] as HTMLDivElement[]
    this.links = [...this.element.querySelectorAll('.o-nav_link')] as HTMLAnchorElement[]
    this.items = [...this.element.querySelectorAll('.o-nav_slide')] as HTMLDivElement[]

    this.links.map((link) => {
      // FIXME: #で判断てやばすぎ
      if (link.getAttribute('href') === '#') {
        link.addEventListener('click', this.onPressLink)
      }
      const title = link.querySelector('.o-nav_item_title') as HTMLParagraphElement
      this.textAnimations.set(title, new TextAnimation(title))
    })

    this.textAnimations.forEach((val) => {
      val.init()
    })

    this.backs.map(back => {
      back.addEventListener('click', this.onPressGoBack)
    })

    this.window.onResize.connect(this.resize)

    this.observe(appSelectors.selectIsOpenGlobalNav, (isOpen) => {
      isOpen
      ? this.open()
      : this.hide()
    })

    this.resize()

  }

  open() {
    this.element?.classList.add('show')
    const current = this.items[0]
    this.showSlide(current)

    let index = 0
    this.textAnimations.forEach((val) => {
      setTimeout(() => {
        val.show()
      }, 50 * index)
      index++
    })
  }

  hide() {
    this.element?.classList.remove('show')
    this.items.map(item => {
      this.hideSlide(item)
    })
    this.textAnimations.forEach((val) => {
      val.hide()
    })
    this.currentIndex = 1
  }

  didUnmount() {
    this.backs.map(back => {
      back.removeEventListener('click', this.onPressGoBack)
    })
    this.items.map((item) => {
      item.removeEventListener('click', this.onPressLink)
    })
  }

  findItem(index: number) {
    return this.items.find(i => parseInt(i.dataset['index'] || '-1', 10) === index)
  }

  onPressLink(e: MouseEvent) {
    const target = e.currentTarget as HTMLDivElement
    const i = target.dataset['index'] || '-1'
    const index = parseInt(i, 10)
    const current = this.findItem(0)
    current && this.toPrevSlide(current, '-110%')
    const next = this.findItem(index)
    next && this.toCurrentSlide(next, '110%')
    this.currentIndex = index
  }

  onPressGoBack(e: MouseEvent) {
    const current = this.findItem(this.currentIndex)
    current && this.toPrevSlide(current, '110%')
    const next = this.findItem(0)
    next && this.toCurrentSlide(next, '-110%')
    this.currentIndex = 1
  }

  showSlide(target: HTMLElement) {
    target.style.visibility = 'visible'

    const prevAnime = this.anime.get(target)
    prevAnime?.pause()
    const animeInstance = anime({
      duration: 500,
      easing: 'easeOutCubic',
      targets: target,
      opacity: 1,
    })
    this.anime.set(target, animeInstance)
  }

  hideSlide(target: HTMLElement) {
    const prevAnime = this.anime.get(target)
    prevAnime?.pause()
    const animeInstance = anime({
      duration: 500,
      easing: 'easeOutCubic',
      targets: [target],
      opacity: 0,
      complete: () => {
        target.style.transform = 'translateX(0%)'
        target.style.visibility = 'hidden'
      }
    })
    anime({
      duration: 0,
      translateX: '0%',
      targets: target.querySelectorAll('.o-nav_link')
    })
    this.anime.set(target, animeInstance)
  }

  toCurrentSlide(target: HTMLElement, beginX: string) {
    target.style.visibility = 'visible'
    target.style.opacity = '1'
    const list = [...target.querySelectorAll('.m-nav-item_link, .m-nav-subitem_link, .o-nav_link')]
    anime.timeline({
      easing: 'easeOutCubic',
    }).add({
      delay: 300,
      duration: 300,
      easing: 'easeOutCubic',
      targets: target,
      translateX: [beginX, '0%'],
    }).add({
      duration: 500,
      easing: 'easeOutCubic',
      delay: anime.stagger(20),
      targets: list,
      translateX: [beginX, '0%'],
    }, '-=250')
  }

  toPrevSlide(target: HTMLElement, endX: string) {
    anime.timeline({
      easing: 'easeOutCubic',
    })
    .add({
      duration: 300,
      delay: anime.stagger(20),
      targets: target.querySelectorAll('.m-nav-item_link, .m-nav-subitem_link, .o-nav_link'),
      translateX: ['0%', endX],
    }, '')
    .add({
      duration: 300,
      easing: 'easeOutCubic',
      targets: target,
      translateX: ['0%', endX],
      complete: () => {
        target.style.visibility = 'hidden'
        target.style.opacity = '1'
      }
    }, '-=250')
  }

  resize() {
    if (this.mq.isPhone()) {
      const height = window.innerHeight
      this.element && (this.element.style.height = `${height}px`)
    } else {
      this.element && (this.element.style.height = '')
    }
  }
}
